import { CustomFeatureType } from "../../../../../api/types";
import {
  ObjectValidatorsMap,
  ObjectMapValidator,
  rangeCharactersValidator,
} from '../../../../../components/Validator';

const FeatureTypeValidatorMap: ObjectValidatorsMap<CustomFeatureType> = {
  name: rangeCharactersValidator(0, 100, 'Feature type name is required with a max length of 100 characters.'),
  description: rangeCharactersValidator(-1, 250, 'The description has a maximum length of 250 characters.')
}

const FeatureTypeValidator = new ObjectMapValidator<CustomFeatureType>(FeatureTypeValidatorMap);

export default FeatureTypeValidator;